import React, { useState } from 'react';
import clsx from 'clsx';
import Link from 'next/link';
import { CircularProgress } from '@mui/material';
import { Button, buttonVariants } from '@/shadcn/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";

const PricingButton = _ref => {
  let {
    hasActiveSession = false,
    hasActiveSubscription = false,
    currentSubscriptionType,
    subscriptionPlan,
    signUpLinkText = 'Try for free',
    redirectToCheckout
  } = _ref;
  const {
    0: isLoading,
    1: setIsLoading
  } = useState(false);

  const handleCheckout = () => {
    setIsLoading(true);
    redirectToCheckout(subscriptionPlan.priceId).finally(() => setIsLoading(false));
  };

  if (hasActiveSession && currentSubscriptionType === subscriptionPlan.nickname) {
    return /*#__PURE__*/_jsx(Button, {
      className: "w-full cursor-default",
      children: "Current plan"
    });
  }

  if (hasActiveSession) {
    return /*#__PURE__*/_jsx(Button, {
      variant: 'outline',
      className: "w-full",
      onClick: handleCheckout,
      children: isLoading ? /*#__PURE__*/_jsx(CircularProgress, {
        size: 20,
        color: "inherit"
      }) : hasActiveSubscription ? 'Choose this plan' : 'Purchase now'
    });
  }

  return /*#__PURE__*/_jsx(Link, {
    href: "/signup?redirect=/account/billing",
    className: clsx('w-full', buttonVariants({
      variant: 'outline'
    })),
    children: signUpLinkText
  });
};

export default PricingButton;